"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
var _link = require("../link");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SectionHeader = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, item.label);
};
SectionHeader.propTypes = {
  item: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired
  })
};
const SectionLink = _ref2 => {
  let {
    first,
    item
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default.Item, {
    href: (0, _link.absolute)(item.link),
    rel: "noopener noreferer",
    className: `${first ? 'column-header' : ''}`
  }, item.label);
};
SectionLink.propTypes = {
  first: _propTypes.default.bool,
  item: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    link: _propTypes.default.any.isRequired
  })
};
const LinkColumn = _ref3 => {
  let {
    items
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg"
  }, items.map((navItem, idx) => {
    switch (navItem.itemType) {
      case 'sectionheader':
        return /*#__PURE__*/_react.default.createElement(SectionHeader, {
          key: `${navItem.label}-header`,
          item: navItem
        });
      case 'link':
        return /*#__PURE__*/_react.default.createElement(SectionLink, {
          key: `${navItem.label}-link`,
          item: navItem,
          first: idx === 0
        });
      /* istanbul ignore next */
      default:
        return null;
    }
  }));
};
LinkColumn.propTypes = {
  items: _propTypes.default.array.isRequired
};
const ImageColumn = _ref4 => {
  let {
    image
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg spotlight"
  }, image?.ctaTop?.label !== undefined && image?.ctaTop?.link?.url !== undefined && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "mm-spacing--minor btn btn-primary btn-block",
    href: (0, _link.absolute)(image?.ctaTop?.link)
  }, image?.ctaTop?.label), /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _link.absolute)({
      url: image?.img?.src
    }),
    alt: image?.img?.alt
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "h4"
  }, image?.label), /*#__PURE__*/_react.default.createElement("p", null, image?.description), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "secondary",
    href: (0, _link.absolute)(image?.link)
  }, /*#__PURE__*/_react.default.createElement("span", null, image?.cta?.label), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-arrow"
  })));
};
ImageColumn.propTypes = {
  image: _propTypes.default.any
};
const SecondTierMegaNavColumn = _ref5 => {
  let {
    imageColumn,
    navImage,
    navItems
  } = _ref5;
  if (imageColumn === false) {
    return /*#__PURE__*/_react.default.createElement(LinkColumn, {
      items: navItems
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(ImageColumn, {
      image: navImage
    });
  }
};
SecondTierMegaNavColumn.propTypes = {
  imageColumn: _propTypes.default.bool,
  navImage: _propTypes.default.any,
  navItems: _propTypes.default.any
};
SecondTierMegaNavColumn.defaultProps = {
  imageColumn: false
};
var _default = exports.default = SecondTierMegaNavColumn;